import * as React from 'react';
import { EntityTypeIconsProvider, defaultEntityTypeIconsDefinition } from '@shapeable/icons';
import { EntityTypeCardsProvider, defaultEntityTypeCardsSet } from '../context/entity-type-cards-context';
import { EntityTypeTooltipsProvider, defaultEntityTypeTooltipsSet } from '../context/entity-type-tooltips-context';
import { EntityDataProviders } from './entity-data-providers';
import deepmerge from 'deepmerge';
import { EntityTypeLabelsProvider, defaultEntityTypeLabelsSet } from '../context/entity-type-labels-context';
import { EntityTypePluralLabelsProvider, defaultEntityTypePluralLabelsSet } from '../context/entity-type-plural-labels-context';
import { EntityTypeCountIconsProvider, defaultEntityTypeCountIconsSet } from '../context/entity-type-count-icons-context';
import { EntityTypeImagesProvider, defaultEntityTypeImages } from '../context/entity-type-images-context';
import { defaultEntityTypeValuesSet, EntityTypeValuesProvider } from '../context/entity-type-values-context';
export var defaultEntityConfig = {
  dataProviders: [],
  countIcons: defaultEntityTypeCountIconsSet,
  icons: defaultEntityTypeIconsDefinition,
  cards: defaultEntityTypeCardsSet,
  tooltips: defaultEntityTypeTooltipsSet,
  labels: defaultEntityTypeLabelsSet,
  pluralLabels: defaultEntityTypePluralLabelsSet,
  images: defaultEntityTypeImages,
  values: defaultEntityTypeValuesSet
};
export var EntityConfigProvider = function (_a) {
  var value = _a.value,
    children = _a.children;
  var defaultValue = deepmerge(defaultEntityConfig, value || {});
  return React.createElement(EntityDataProviders, {
    items: defaultValue.dataProviders
  }, React.createElement(EntityTypeCountIconsProvider, {
    value: defaultValue.icons
  }, React.createElement(EntityTypeIconsProvider, {
    value: defaultValue.icons
  }, React.createElement(EntityTypeValuesProvider, {
    value: defaultValue.values
  }, React.createElement(EntityTypeCardsProvider, {
    value: defaultValue.cards
  }, React.createElement(EntityTypeTooltipsProvider, {
    value: defaultValue.tooltips
  }, React.createElement(EntityTypeImagesProvider, {
    value: defaultValue.images
  }, React.createElement(EntityTypeLabelsProvider, {
    value: defaultValue.labels
  }, React.createElement(EntityTypePluralLabelsProvider, {
    value: defaultValue.pluralLabels
  }, children)))))))));
};